/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { SxProps } from '@mui/material/styles';

export const facetNavigationAccordionSummarySX: SxProps = {
	p: 0,
	pl: 0,
	mb: '0px',
	cursor: 'pointer',
};
